module.exports = __webpack_public_path__ + "img/zubehoer_lapschlauch.1963368c.jpg";